export const NODE_DETAILS = {
	node_id: {
		id: 'node_id',
		name: 'Node Id',
		mandatory: true,
	},
	node_display_name: {
		id: 'node_display_name',
		name: 'Node Display Name',
		mandatory: true,
	},
	region: {
		id: 'region',
		name: 'Region',
		mandatory: true,
	},
	physical_address_line1: {
		id: 'physical_address_line1',
		name: 'Address Line 1',
		mandatory: true,
	},
	physical_address_line2: {
		id: 'physical_address_line2',
		name: 'Address Line 2',
		mandatory: false,
	},
	physical_address_line3: {
		id: 'physical_address_line3',
		name: 'Address Line 3',
		mandatory: false,
	},
	physical_address_pincode: {
		id: 'physical_address_pincode',
		name: 'Zip/Pincode',
		mandatory: true,
	},
	physical_country: {
		id: 'physical_country',
		name: 'Physical Country',
		mandatory: true,
		constraintText:
			'Choosing the Region is mandatory to see the options for Physical country.',
	},
	physical_address_city: {
		id: 'physical_address_city',
		name: 'City',
		mandatory: true,
		constraintText:
			'Please choose Zipcode and country first. City might be pre filled based on choosen ZipCode and country.',
	},
	physical_address_state: {
		id: 'physical_state',
		name: 'State',
		mandatory: true,
		constraintText:
			'Please choose Zipcode and country first. State might be pre filled based on choosen ZipCode and country.',
	},
	time_zone: {
		id: 'time_zone',
		name: 'Timezone',
		mandatory: true,
	},
	comp_parent_station_code: {
		id: 'comp_parent_station_code',
		name: 'Comp Parent Station Code',
		mandatory: true,
	},
};

export const ANCHOR_POINT_WORKFLOW_TYPE = 'ANCHOR_POINT_WORKFLOW';
export const NODE_CAPABILITY = 'ANCHOR_POINT';
export const GET_ACTIVE_COMP_STATIONS_TASK = 'GetActiveCompStationsTask';
export const ANCHOR_POINT_NODE_TYPE = 'anchor_point';
export const CMDS_INACTIVE_STATUS = 'INACTIVE';
export const SNOW_USER_IDENTIFIER = 'SNOW';
export const SELF_SERVICE_WORKFLOW_GROUP = 'SelfServiceWorkflow';
